import React, { Component } from 'react';
import {Paper, Grid, Typography, Button, IconButton, TextField} from '@material-ui/core';
import * as Gserv from '../services/GatewayService';
// import Settings from '@material-ui/icons/Settings';
import DatasheetView from './DatasheetView';
// import DropDown from './DropDown';
import { PersonAddTwoTone } from '@material-ui/icons';
import moment from 'moment';

export default class AssessmentGroupUsers extends Component {

    constructor(props) {
        super(props);
        this.reset_state = {
            assessments_view: false,
            empl_num_error: null,
            empl_num_input: '',
            name_error: null,
            name_input: '',
            can_submit: true,
            writing: false,
            deleting: false,
            error: false,
            error_message: '',
            querying: true,
            matrix_array: [],
            show_dialogue: false,
            form_view: false,
            form_data: {},
            current_record: {},
            search_name: '',
            search_number: '',
            search_ready: false,
            searching: false,
            users_array: [],
            show_users: false,
            primary_button_enabled: false,
            primary_button_text: 'Add Individual'
        }
        this.state = {  //Note: assessmemt_groups not reset
            assessments_view: false,
            empl_num_error: null,
            empl_num_input: '',
            name_error: null,
            name_input: '',
            can_submit: true,
            writing: false,
            deleting: false,
            error: false,
            error_message: '',
            querying: true,
            matrix_array: [],
            show_dialogue: false,
            form_view: false,
            form_data: {},
            current_record: {},
            search_name: '',
            search_number: '',
            search_ready: false,
            searching: false,
            users_array: [],
            show_users: false,
            primary_button_enabled: false,
            primary_button_text: 'Add Individual'            
        };

        this.datasheetFieldSpecs = [
            { field: 'name', headerName: 'Employee', width: 180},
            { field: 'job_title', headerName: 'Job Title', width: 160},
            { field: 'store_code', headerName: 'Store Code', width: 120, sortable:false},
            { field: 'store', headerName: 'Store', width: 160},
            { field: 'region', headerName: 'Region', width: 160},
            { field: 'date_of_entry', headerName: 'DOE', width: 120},
            { field: 'reports_to_rom', headerName: 'Manager Code', align: 'center',width: 125},
            { field: 'supervisor', headerName: 'LM / Supervisor', width: 180},
        ]

        this.datasheetFieldSpecs2 = [
            { field: 'include', headerName: 'Add', width: 80, headerAlign: 'center', align:'center',
            sortable: false,
            renderCell: (parms) => (
                <IconButton onClick={()=>this.addUser(parms)}>
                    <PersonAddTwoTone/>
                </IconButton>
            )},
            { field: 'name', headerName: 'Employee', width: 180},
            { field: 'job_title', headerName: 'Job Title', width: 160},
            { field: 'store_code', headerName: 'Store Code', width: 120, sortable:false},
            { field: 'store', headerName: 'Store', width: 160},
            { field: 'region', headerName: 'Region', width: 160},
            { field: 'date_of_entry', headerName: 'DOE', width: 120},
            { field: 'reports_to_rom', headerName: 'Manager Code', align: 'center',width: 125},
            { field: 'supervisor', headerName: 'LM / Supervisor', width: 180},

        ]

        this.input_fieldSpecs = [
            {field: "assessment_group_id", headerName: "Select Group", f_inputType:'dropdown', f_show:true, f_required:true},
        ]
    }

    componentDidMount = () => {

        Gserv.sendCommand('query_user_group_matrix',this.props.gwt,{
            assessment_group_id: this.props.group.assessment_group_id
        })
        .then(reply=>{
            // console.log('query_user_group_matrix reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (query_user_group_matrix) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                console.log('error on return from Gserv (query_user_group_matrix) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                // clean formats for display
                if (reply.Records){
                let doe = null;
                let cycle_array = reply.Records;
                    for (var i=0;i<cycle_array.length;i++){
                        doe = new moment(cycle_array[i].date_of_entry).format("YYYY-MM-DD");
                        cycle_array[i].date_of_entry = doe;
                        // cycle_array[i].requires_nomination = cycle_array[i].requires_nomination? "YES" : "";
                    }
                }
                this.setState({querying:false, matrix_array:reply.Records?reply.Records : []});
            }
        });
    };

    editAssessments = (parms) => {
        // console.log('edit assessments with parms :>> ', parms);
        this.setState({current_record:parms.row});
    }

    processForm = (e) => {
        e.preventDefault();
        // console.log('this.state.form_data :>> ', this.state.form_data);
        this.setState({writing:true, primary_button_enabled:false});
        //set state updating here...
        
        if (this.state.current_record.id){
            //this is an update

            // Gserv.sendCommand('update_cycle',this.props.gwt,{
            //     form_data : this.state.form_data,
            //     id : this.state.current_record.id
            // })
            // .then(reply => {
            //     // console.log('update reply :>> ', reply);
            //     if (reply.error){
            //         console.log('error on return from Gserv (update_cycle) :>> ', reply);
            //         this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            //     } else if (reply.statusCode===409) {
            //         console.log('error on return from Gserv (update_cycle) :>> ', reply);
            //         this.setState({error:true,error_message:"A cycle with this code or name already exists.",querying:false});
            //     } else if (reply.Result!=="Success") {
            //         console.log('error on return from Gserv (update_cycle) :>> ', reply);
            //         this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            //     } else {
            //         this.setState(this.reset_state);
            //         this.componentDidMount();
            //     }
            // });           

        } else {
            //this is a create
            Gserv.sendCommand('create_cycle_user_registry_entry',this.props.gwt,{
                form_data : this.state.form_data,
                cycle_id : this.props.cycle.cycle_id
            })
            .then(reply => {
                // console.log('create reply :>> ', reply);
                if (reply.error){
                    console.log('error on return from Gserv (create_cycle_user_registry_entry) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else if (reply.statusCode===409){
                    console.log('error on return from Gserv (create_cycle_user_registry_entry) :>> ', reply);
                    this.setState({error:true,error_message:"This Individual is already speccifically included or excluded for this Cycle.",querying:false});
                } else if (reply.Result!=="Success"){
                    console.log('error on return from Gserv (create_cycle_user_registry_entry) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else {
                    this.setState(this.reset_state);
                    this.componentDidMount();
                }
            });
        }
    }

    addUser = (parms) => {
        this.setState({writing:true, primary_button_enabled:false});
        
        Gserv.sendCommand('create_group_user_registry_entry',this.props.gwt,{
            form_data : {
                employee_number : parms.id,
            },
            assessment_group_id : this.props.group.assessment_group_id
        })
        .then(reply => {
            // console.log('create reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (create_group_user_registry_entry) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reply.statusCode===409){
                console.log('error on return from Gserv (create_group_user_registry_entry) :>> ', reply);
                this.setState({error:true,error_message:"This Individual is already part of this Asessment Group.",querying:false});
            } else if (reply.Result!=="Success"){
                console.log('error on return from Gserv (create_group_user_registry_entry) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                this.setState(this.reset_state);
                this.componentDidMount();
            }
        });
    }

    handleFieldUpdate = (fieldObj) => {
        // console.log('called field update...');
        // console.log('child field update:',fieldObj);
        // console.log(this.state.current_record);
        // eslint-disable-next-line eqeqeq
        if (fieldObj.value==''){fieldObj.value=null}
        let myFormData = this.state.form_data;
        myFormData[fieldObj.field] = fieldObj.value;
        this.setState({form_data:myFormData});
        // console.log('current_record value : ',this.state.current_record[fieldObj.field]);
        // console.log('New value : ', fieldObj.value);
        // eslint-disable-next-line eqeqeq
        if(this.state.current_record[fieldObj.field]!=fieldObj.value){
            const truthyCurrentRec = this.state.current_record[fieldObj.field]? true : false;
            const truthyFieldObj = fieldObj.value ? true : false;
            //exclude nulls vs '' vs false etc.
            if (truthyCurrentRec||truthyFieldObj){
                // console.log('found update...');
                this.setState({primary_button_enabled:true});
            }
        } 
    }

    handleUpdate = (record) => {
        // N/A - no edit on this form
        // console.log('record for update :>> ', record);
        // this.setState({show_dialogue:true});
        //Hide just while testing modal...
        // this.setState({current_record:record.row,form_view:true,primary_button_enabled:false,primary_button_text:'Update Assessment cycle'});
    }

    handleDelete = (record) => {
        // console.log('record for delete :>> ', record);

        // this.setState({show_dialogue:true});
        //Hide just while testing modal...
        this.setState({deleting:true,querying:true});
        Gserv.sendCommand('delete_group_user_registry_entry',this.props.gwt,{
            group_user_registry_id: record.id
        })
        .then(reply => {
            // console.log('delete reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (delete_group_user_registry_entry) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reply.Result!=="Success"){
                console.log('error on return from Gserv (delete_group_user_registry_entry) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                this.setState(this.reset_state);
                this.componentDidMount();
            }
        });

    }

    // openSearch = (parms) => {
    //     // console.log('edit assessments with parms :>> ', parms);
    //     this.setState({current_record:parms.row,nominate_view:true});
    // }

    runSearch = (e) => {
        e.preventDefault();
        // console.log('e :>> ', e);
        
        if (!this.state.search_name&&!this.state.search_number){return}

        this.setState({searching:true, search_ready:false});
        Gserv.sendCommand('find_users_for_group_registry',this.props.gwt,{
            search_string: this.state.search_name? this.state.search_name : this.state.search_number,
            search_type: this.state.search_name? 'surname' : 'employee number'
        })
        .then(reply => {
            // console.log('search reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (find_users_for_group_registry) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us."});
            } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                console.log('error on return from Gserv (find_users_for_group_registry) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us."});
            } else if (reply.Result!=="Success"){
                //not broken, but for some reason couldn't update / add record
                if (reply.statusCode===204){
                    this.setState({error:true,error_message:"No employee records found matching the search."});
                } else {
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us."})
                }
            } else {
                if (reply.Records){
                    let record_array = reply.Records;
                    let DOE = null;
                    for (var i=0;i<record_array.length;i++){
                        DOE = new moment(record_array[i].date_of_entry).format("YYYY-MM-DD");
                        record_array[i].date_of_entry = DOE;
                    }
                }
                this.setState({users_array:reply.Records,show_users:true,searching:false,search_ready:true});

            }
        });
    }

    resetMe = () => {
        this.setState(this.reset_state);
        this.componentDidMount();
    }

    render() {
        return (
            <Grid
                container
                direction='column'
                justifyContent='center'
                alignContent='center'
                // style={{backgroundColor:'yellow'}}
            >
                
                <Grid item>
                <Paper
                    elevation={3}
                    style={{
                        width:1300
                    }}
                >
                    <Typography
                        style={{paddingTop:15}}
                    >
                       {this.props.group.assessment_group}
                    </Typography> 
    
                    <hr/>
                    <Typography
                        color='primary'
                        style={{paddingTop:15}}
                    >
                        Add an Individual Employee to this Assessment Group
                    </Typography>
                    <Grid
                        container
                        direction='row'
                        justifyContent='center'
                        alignContent='center'
                        style={{padding:15}}
                    >
                        {!this.state.form_view&&
                        <div>
                        <Button
                            variant='contained'
                            color='primary'
                            // type='submit'
                            onClick={()=>this.setState({form_view:true,primary_button_text:'Add Employee to Group',current_record:{}})}
                            disabled={this.state.form_view}
                        >
                            Add Employee to Group
                        </Button>
                        <Button 
                            // type='button'
                            variant='outlined'
                            disabled={this.state.writing}
                            onClick={()=>this.props.setParentState({users_view:false})}
                            style={{marginLeft:'15px'}}
                        >
                            Back
                        </Button>
                        </div>}
                    </Grid>
                </Paper>
                </Grid>
                <Grid item>
                    <Typography color='secondary' style={{Width:1300,maxWidth:1300, textAlign:'center'}}>{this.state.error_message}</Typography>
                    {this.state.error&&<Button color='primary' variant='outlined' onClick={this.resetMe}>Reset</Button>}
                </Grid>

                {/* {this.state.querying&&
                <Grid item>
                    <br/>
                    <Settings className='icn-spinner' /> Querying...
                </Grid>} */}

                {/* Datagrid goes here */}
                {!this.state.form_view&&
                <DatasheetView 
                    dataset={this.state.matrix_array}
                    fieldspecs={this.datasheetFieldSpecs}
                    delete={true}
                    edit={false}
                    handleDelete={this.handleDelete}
                    handleEdit={null}
                    loading={this.state.querying}
                    deleteHeaderName={'Delete'}
                    pagesize={8}
                />}

                {this.state.form_view&&
                <div>    
                <hr/>    
                <Typography
                    color='primary'
                    style={{paddingTop:10}}
                >
                    Please select an individual employee to add to Assessment Group
                </Typography>
                <Typography>
                    {}
                </Typography>

                <Grid
                    container
                    direction='column'
                    justifyContent='space-evenly'
                    alignContent='center'
                    style={{padding:15}}
                >

                    <form onSubmit={this.runSearch}>
                        {/* <TextField
                            // color='primary'
                            autoComplete="off"
                            autoCorrect="off"
                            autoCapitalize="on"
                            autoFocus={false}
                            inputProps={{maxLength: 10 }}
                            error={this.state.empl_num_error}
                            // id="filled-error-helper-text"
                            label={'Employee Number'}
                            // helperText={'Please enter your surname'}
                            variant='outlined'
                            // placeholder={this.state.said_switch ? 'South African ID Number' : 'E.g. Foreign Passport No.'}
                            value={this.state.empl_num_input}
                            onChange={(e) => {
                                const outText = e.target.value.replace(/[^0-9]+/g, '');   
                                const can_sub = (this.state.name_input.length >=3 && this.state.id_input && outText.length>0)
                                this.setState({empl_num_input: outText, empl_num_error: false, can_submit:can_sub});
                            }}
                            required
                            disabled={this.state.registering}
                            // inputRef={(element) => {this.textInput=element}}
                        /> */}
                        <TextField
                            autoComplete="off"
                            autoCorrect="off"
                            autoCapitalize="on"
                            autoFocus={true}
                            label={'Surname Search'}
                            variant='outlined'
                            value={this.state.search_name}
                            onChange={(e) => {
                                const outText = e.target.value.replace(/[^ A-Za-z]+/g, '').toUpperCase();
                                const can_sub = (outText.length>2);
                                this.setState({search_name: outText, search_number: "", search_ready: can_sub, error: false});
                            }}
                            // required
                            style={{marginBottom:'10px', marginRight:'10px'}}
                            disabled={this.state.searching}
                        />
                        
                        <TextField
                            autoComplete="off"
                            autoCorrect="off"
                            autoCapitalize="off"
                            autoFocus={false}
                            label={'Employee # Search'}
                            variant='outlined'
                            value={this.state.search_number}
                            onChange={(e) => {
                                const outText = e.target.value.replace(/[^ A-Za-z0-9]+/g, '').toUpperCase();
                                const can_sub = (outText.length>2);
                                this.setState({search_number: outText, search_name:"", search_ready: can_sub, error: false});
                            }}
                            // required
                            style={{marginBottom:'10px', marginLeft:'10px'}}
                            disabled={this.state.searching}
                        />
                        <br/>
                        <Button
                            variant='contained'
                            color='primary'
                            type='submit'
                            disabled={!this.state.search_ready}
                        >
                            Search
                        </Button>
                        <Button
                            variant='contained'
                            onClick={()=>this.setState({form_view:false,search_name:'',search_ready:false,searching:false,current_record:{},error:false,error_message:'',show_users:false})}
                            style={{marginLeft:'10px'}}
                            // color='primary'
                            // type='submit'
                            disabled={this.state.writing}
                        >
                            Back
                        </Button>
                    </form>
                </Grid>
                </div>}

                {this.state.show_users&&
                <DatasheetView 
                    dataset={this.state.users_array}
                    fieldspecs={this.datasheetFieldSpecs2}
                    delete={false}
                    edit={false}
                    handleDelete={null}
                    handleEdit={null}
                    loading={this.state.searching}
                    deleteHeaderName={'Delete'}
                    height={350}
                />}
     

            </Grid>
        );
    }
    
}